import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Layout } from '@/Components/Layouts';
import { Button, Icon } from '@/Components/UI';
import { LinkHelper } from '@/Services';
import { ApiV2 } from '@/Services/api';
import { NotifiableType } from '@/Services/api/methods/v2/Notifications/request';
import { StationMonitoringResource } from '@/Services/api/methods/v2/Notifications/response';
import { notificationsStoreSelectors } from '@/Store/notifications/notificationsState';

import { DeviceCard } from '../DeviceCard';
import { NotifiableFilters } from '../NotifiableFilters';
import { NotificationsList } from '../NotificationsList';
import S from './styles.module.scss';

export const StationNotifications: FC = () => {
    const { stationId } = useParams();
    const navigator = useNavigate();

    const readNotifications = notificationsStoreSelectors.use.readNotifications();

    const [station, setStation] = useState<StationMonitoringResource>();

    const handleReadAllClick = () => {
        readNotifications({
            notifiable: {
                type: NotifiableType.STATION,
                id: Number(stationId),
            },
            notifications_ids: [],
        });
    };

    useEffect(() => {
        ApiV2.notifications()
            .getStation(Number(stationId))
            .onNotFound(() => {
                navigator(LinkHelper.iRomaScentsNotifications);
            })
            .onForbidden(() => {
                navigator(LinkHelper.iRomaScentsNotifications);
            })
            .onSuccess((res) => {
                setStation(res.data.station);
            });
    }, [stationId, navigator]);

    return (
        <Layout
            name="station_notifications"
            breadcrumbs={[
                { name: 'Notifications', link: LinkHelper.iRomaScentsNotifications },
                { name: station?.name ?? '', current: true },
            ]}
            nobg
        >
            <div className={S.header}>
                <div className={S.header_top}>
                    <h1 className={S.header_title}>{station?.name}</h1>
                    <div className={S.back} onClick={() => navigator(-1)}>
                        <Icon name="chevron-left" size={24} color="currentColor" />
                        <span>Back</span>
                    </div>
                </div>
                <div className={S.information}>
                    <div className={S.information_item}>
                        <span className={S.information_title}>App Version</span>
                        <span className={S.information_name}>
                            {station?.app_version} {station?.app_version_build} {station?.is_app_update_available && <Icon name="warning" size={14} />}
                        </span>
                    </div>
                </div>
                <div className={S.actions}>
                    <NotifiableFilters />
                    <Button onClick={handleReadAllClick} color="transparent" className={S.read}>
                        Read All
                    </Button>
                </div>
            </div>
            <div className={S.devices}>
                {station?.devices.map((device) => (
                    <DeviceCard stationId={station.id} device={device} key={`device-${device.id}`} />
                ))}
            </div>
            <NotificationsList id={Number(stationId)} type={NotifiableType.STATION} />
        </Layout>
    );
};
